module.exports = __webpack_public_path__ + "img/sierra-club.5e4c58c2.png";